import VIcon from '../VIcon.jsx';

const DEFAULT_SIZE = '1em';
const VIEW_BOX = '0 -960 960 960';

const materialSymbol = (label, path) => {
  const MaterialSymbol = ({ size = DEFAULT_SIZE, ...props }) => (
    <VIcon role="img" aria-hidden="false" aria-label={label} {...props} asChild>
      <svg viewBox={VIEW_BOX} width={size} height={size} fill="currentColor">
        <path d={path} />
      </svg>
    </VIcon>
  );

  MaterialSymbol.displayName = label;

  return MaterialSymbol;
};

export default materialSymbol;
